(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentAdvancedFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'documentService', 'documentTypeService', 'documentContainerService', 'containerTypeService', 'authExtend', 'storageService', 'fileService', 'fileDownloader', 'userQueryService', '$q', '$uibModal', 'documentAndContainerFindService', 'documentAction', 'userService', '$filter',
            function documentTypeController($scope, config, $state, $translate, errors, documentService, documentTypeService, documentContainerService, containerTypeService, auth, storageService, fileService, fileDownloader, userQueryService, $q, $modal, documentAndContainerFindService, documentAction, userService, $filter) {
                $scope.itemsPerPageOptions = [15, 50, 100, 200]
                $scope.find = storageService.getDocumentFilter();
                $scope.querydBtn = auth.isInRole('USER QUERIES');
                $scope.hasFullText = auth.isInRole('FULLTEXT');
                $scope.hasCalendarBtn = auth.isInRole('CALENDAR READ') && $scope.find.fromCalendar;
                $scope.showDocumentContainers = auth.isInRole('DOCUMENTCONTAINER READ');
                $scope.showDocumentContainersMetadatas = auth.isInRole('DOCUMENT AND CONTAINER FIND');

                $scope.maxSearchCaracters = config.searchTableMaxLength();
                // DOCUMENTCONTAINER WRITE
                $scope.dateTimePickerFromOptions = {};
                $scope.dateTimePickerToOptions = {};

                $scope.loadActions = function (dtId) {
                    documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], dtId).then(function (r) { $scope.downloadBtn = r; });
                    documentTypeService.isDoctypeInRole(['FILE READ'], dtId).then(function (r) { $scope.viewPDFBtn = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSION READ'], dtId).then(function (r) { $scope.versionView = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE', 'DOCUMENT WRITE'], dtId).then(function (r) { $scope.modifyOptions = r; });
                    documentTypeService.isDoctypeInRole(['FILE MASSIVE DOWNLOAD'], dtId).then(function (r) { $scope.masiveDownloadOptions = r; });
                    documentTypeService.isDoctypeInRole(['SHARE'], dtId).then(function (r) { $scope.shareBtn = r; });
                }

                $scope.fullTextMinLength = config.fullTextMinLength();

                $scope.headers = [];
                $scope.sortableHeaders = [];
                $scope.items = [];

                $scope.all = { name: "All", id: 0 };

                $scope.aux = {
                    selectedDocumentTypes: [],
                    categoires: []
                };

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };

                $scope.accordionState = {
                    isOpen: true
                };

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.hideAllVersion = !auth.isInRole('DOCUMENTVERSION READ');
                $scope.containerOptions = auth.isInRole('DOCUMENTCONTAINER WRITE');

                function checkType(value) {

                    for (var i in $scope.find.selectedDocumentTypes) {
                        if ($scope.find.selectedDocumentTypes.hasOwnProperty(i)) {
                            if ($scope.find.selectedDocumentTypes[i].id === value.id) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                $scope.Load = function () {
                    $scope.items = [];
                    $scope.documentTypes = $scope.documentTypes !== null ? $scope.documentTypes : [];
                    $scope.showResult = false;
                    $scope.itemsTmp = [];
                    $scope.aux = {
                        selectedDocumentTypes: [],
                        categoires: [],
                        containers: []
                    };
                    $scope.auxDocumentType = {};
                    $scope.auxContainerType = {};
                    $scope.optionsDocumentTypes = [];
                    $scope.optionsUserQueries = [];
                    $scope.optionsContainerTypes = [];

                    $scope.loadContainerTypes();

                    $scope.find = storageService.getDocumentFilter();

                    documentTypeService.getFunctionsTypes(['DOCUMENT READ', 'DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                        $scope.optionsDocumentTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });

                        $scope.aux.selectedDocumentTypes = $scope.optionsDocumentTypes.filter(checkType);

                        if ($scope.aux.selectedDocumentTypes.length === 0 && $scope.optionsDocumentTypes.length === 1) {
                            $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                            $scope.aux.selectedDocumentTypes.push($scope.optionsDocumentTypes[0]);
                        }

                        if ($scope.find.DocumentTypes.length > 0) {
                            $scope.findDocuments();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });

                    $scope.documentContainFilesFilter();

                    if (auth.isInRole('USER QUERIES')) {
                        userQueryService.get('', 'Documents', null, null).then(function (result) {
                            $scope.optionsUserQueries = result.value;

                            $scope.userQueryId = storageService.getUserQuery().id;

                        }, function (error) {
                            errors.showError(error);
                        });

                        $scope.showBtnSave = true;
                        $scope.showBtnSaveAs = false;

                        if ((storageService.getUserQuery().name !== null) &&
                            (storageService.getDocumentFilter().selectedDocumentTypes.length > 0)) {

                            $scope.showBtnSave = false;
                            $scope.showBtnSaveAs = true;
                        }
                    }

                    $translate(['SearchCriteria']).then(function (translated) {

                        $scope.title = translated.SearchCriteria;
                        $scope.showUserQuery = false;

                        if ((storageService.getUserQuery().name !== null) &&
                            (storageService.getDocumentFilter().selectedDocumentTypes.length > 0) && storageService.getUserQuery().type === 'Documents') {
                            $scope.userQuerySelectedTitle(storageService.getUserQuery().name);
                            $scope.showUserQuery = true;
                        }
                    });
                };

                $scope.userQuerySelectedTitle = function (name) {
                    $scope.userQuerySelected = ' : ' + name;
                };

                $scope.clean = function () {
                    $scope.dateTimePickerFromOptions.clearInput();
                    $scope.dateTimePickerToOptions.clearInput();
                    $scope.aux.selectedDocumentTypes = [];
                    storageService.clearDocumentFilter();
                    $scope.optionsUserQueries = [];
                    $scope.showUserQuery = false;
                    $scope.userQuerySelected = '';
                    $scope.showBtnSave = true;
                    $scope.showBtnSaveAs = false;

                    $scope.find = storageService.getDocumentFilter();

                    $scope.find.selectedContainerType = $scope.optionsContainerTypes[0];
                    $scope.loadDocumentTypes();

                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                };

                $scope.LoadDocumentTypeMetadata = function (documentType) {
                    var documentDocType =
                    {
                        SystemName: documentType.systemName,
                        documentTypeName: documentType.name,
                        documentTypeId: documentType.id,
                        metadatas: []
                    };

                    documentType.metadata.forEach(function (metadata) {
                        if (metadata.isSearchCriteria) {
                            documentDocType.metadatas.push(
                                {
                                    idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                                    metadataId: metadata.metadataId,
                                    metadataValueFrom: undefined,
                                    metadataValueTo: undefined,
                                    metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                    metadataSearchTypeTo: undefined, // cada control pisa el valor
                                    metadataType: metadata.metadataType,
                                    metadataSystemName: metadata.metadataSystemName,
                                    metadataLabel: metadata.metadataLabel,
                                    metadataOptions: metadata.optionValues,
                                    metadataIsMultivalue: metadata.isMultivalue,
                                    maskOptions: metadata.maskOptions,
                                    mask: metadata.metadataMask,
                                    maskPlaceHolder: metadata.metadataMaskPlaceHolder
                                });
                        }
                    });

                    $scope.find.DocumentTypes.push(documentDocType);
                };

                $scope.LoadContainerTypeMetadata = function (containerType) {

                    var documentContType =
                    {
                        SystemName: containerType.systemName,
                        containerTypeName: containerType.name,
                        containerTypeId: containerType.id,
                        metadatas: []
                    };

                    containerType.metadata.forEach(function (metadata) {
                        if (metadata.isSearchCriteria) {
                            documentContType.metadatas.push(
                                {
                                    idObject: documentContType.containerTypeId + '' + metadata.metadataId,
                                    metadataId: metadata.metadataId,
                                    metadataValueFrom: undefined,
                                    metadataValueTo: undefined,
                                    metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                    metadataSearchTypeTo: undefined, // cada control pisa el valor
                                    metadataType: metadata.metadataType,
                                    metadataSystemName: metadata.metadataSystemName,
                                    metadataLabel: metadata.metadataLabel,
                                    metadataOptions: metadata.optionValues,
                                    metadataIsMultivalue: metadata.isMultivalue,
                                    mask: metadata.metadataMask,
                                    maskPlaceHolder: metadata.metadataMaskPlaceHolder
                                });
                        }
                    });

                    $scope.find.containerType = documentContType;
                };

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'Detail', 'DOCUMENT READ').then(function (result) {
                        $scope.LoadDocumentTypeMetadata(result);
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.loadContainerTypes = function () {
                    $scope.optionsContainerTypes = [];
                    if ($scope.showDocumentContainers) {
                        containerTypeService.getFunctionsTypes(['DOCUMENTCONTAINER READ']).then(function (result) {
                            $scope.optionsContainerTypes = result.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });

                            $scope.optionsContainerTypes.splice(0, 0, $scope.all);
                            if (!$scope.find.selectedContainerType) {
                                $scope.find.selectedContainerType = $scope.optionsContainerTypes[0];
                            }

                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                }

                $scope.sortColumn = function (header) {
                    if (header.isSortable) {
                        header.asc = !header.asc;
                        $scope.sortableHeaders.forEach(function (column) {
                            if (column.value === header.value) {
                                column.sorted = true;
                                column.asc = header.asc;

                                var selectedDt = $filter('filter')($scope.documentTypes, { selected: true }, true);

                                $scope.find.DocumentTypes.forEach(function (dt) {
                                    if (dt.documentTypeId === selectedDt[0].id) {
                                        dt.OrderBy = [];
                                        dt.OrderBy.push(column.metadataSystemName);
                                        dt.orderAscendent = column.asc;
                                    }
                                });

                                $scope.findDocuments();
                            }
                            else {
                                column.sorted = false;
                            }
                        });
                    }
                };

                $scope.removeDocumentType = function (documentType) {

                    var indexOf = -1;
                    var indexAdd = -1;

                    for (var i = 0; i < $scope.find.DocumentTypes.length; i++) {
                        if ($scope.find.DocumentTypes[i].documentTypeId === documentType.id) {
                            indexOf = i;
                            indexAdd = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        $scope.find.DocumentTypes.splice(indexOf, 1);
                    }

                    indexOf = -1;
                    for (i = 0; i < $scope.find.selectedDocumentTypes.length; i++) {
                        if ($scope.find.selectedDocumentTypes[i].id === documentType.id) {
                            indexOf = i;
                            indexAdd = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        $scope.find.selectedDocumentTypes.splice(indexOf, 1);
                    }

                    indexOf = -1;

                    if ($scope.aux.selectedDocumentTypes !== null) {
                        for (var k = 0; k < $scope.aux.selectedDocumentTypes.length; k++) {
                            if ($scope.aux.selectedDocumentTypes[k].id === documentType.id) {
                                indexOf = k;
                                indexAdd = k;
                                break;
                            }
                        }

                        if (indexOf >= 0) {
                            $scope.aux.selectedDocumentTypes.splice(indexOf, 1);
                        }
                    }

                    if (indexAdd >= 0 && $scope.getIndex($scope.optionsDocumentTypes, documentType) < 0) {
                        $scope.optionsDocumentTypes.push(documentType);
                    }



                };

                $scope.loadDocumentTypes = function () {
                    $scope.find.containerType = undefined;

                    if ($scope.find.selectedContainerType.id && $scope.find.selectedContainerType.id !== 0) {

                        containerTypeService.getById($scope.find.selectedContainerType.id,
                            'Detail',
                            'DOCUMENTCONTAINER READ').then(function (result) {
                                //$scope.containerType = containerType;
                                $scope.LoadContainerTypeMetadata(result);
                            },
                                function (error) {
                                    errors.showError(error);
                                });

                        var ids = [];
                        ids.push($scope.find.selectedContainerType.id);

                        documentTypeService.getByContainerId(ids).then(function (result) {
                            $scope.optionsDocumentTypes = result.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });


                            if ($scope.aux.selectedDocumentTypes && $scope.aux.selectedDocumentTypes.length > 0) {
                                $scope.filterDocumentTypes();
                            }
                        },
                            function (error) {
                                errors.showError(error);
                            });
                    } else {
                        documentTypeService
                            .getFunctionsTypes(['DOCUMENT READ', 'DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(
                                function (result) {
                                    $scope.optionsDocumentTypes = result;
                                    $scope.filterDocumentTypes();
                                    $scope.containerType = {};
                                },
                                function (error) {
                                    errors.showError(error);
                                });
                    }
                }

                $scope.filterDocumentTypes = function () {

                    for (var i = $scope.aux.selectedDocumentTypes.length - 1; i >= 0; i--) {

                        var index = $scope.getIndex($scope.optionsDocumentTypes, $scope.aux.selectedDocumentTypes[i]);

                        if (index < 0) {
                            $scope.removeDocumentType($scope.aux.selectedDocumentTypes[i]);
                        } else {
                            $scope.optionsDocumentTypes.splice(index, 1);
                        }
                    }
                }

                $scope.getIndex = function (selected, docType) {
                    var index = -1;

                    for (var i = 0; i < selected.length; i++) {
                        if ((selected[i]).id === docType.id) {
                            return i;
                        }
                    }
                    return index;
                }

                $scope.selectUserQuery = function (uq) {
                    storageService.setUserQuery(angular.copy(uq));

                    storageService.setDocumentFilter(angular.fromJson(storageService.getUserQuery().filters));

                    $scope.find = storageService.getDocumentFilter();

                    $scope.aux.selectedDocumentTypes = $scope.find.selectedDocumentTypes;

                    $scope.userQuerySelectedTitle(storageService.getUserQuery().name);
                };

                $scope.actionFind = function () {
                    $scope.data.currentPage = 1;
                    $scope.data.totalItems = 0;
                    $scope.data.from = 0;
                    
                    $scope.checkAll = false;
                    if (!$scope.find.DocumentTypes || $scope.find.DocumentTypes.length === 0) {
                        return false;
                    }

                    $scope.items = [];
                    $scope.documentTypes = $scope.documentTypes !== null ? $scope.documentTypes : [];
                    $scope.showResult = false;

                    if (!$scope.searchDocuments.$valid || $scope.find.DocumentTypes.length <= 0) {
                        $scope.searchDocuments.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return $scope.findDocuments();

                };

                $scope.FindContainersAndDocuments = function () {
                    if ($scope.showDocumentContainersMetadatas && $scope.find.containerType && $scope.find.containerType.metadatas.length > 0) {
                        var value = false;
                        $scope.find.containerType.metadatas.forEach(function (m) {
                            if ((m.metadataValueFrom && m.metadataValueFrom !== '') || (m.metadataValueTo && m.metadataValueTo !== '') || (m.metadataSearchTypeFrom === 'nullValue' || m.nullValue)) {
                                value = true;
                                return;
                            }
                        });

                        return value;
                    }

                    return false;
                }

                $scope.actionFindFullText = function () {

                    $scope.items = [];
                    $scope.documentTypes = [];
                    $scope.showResult = false;

                    if (!$scope.searchDocuments.$valid || $scope.find.DocumentTypes.length <= 0 || (!!$scope.find.documentFullText && $scope.find.documentFullText.length > 0 && $scope.find.documentFullText.length < 3)) {
                        $scope.searchDocuments.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return $scope.findDocuments();

                };

                $scope.findDocuments = function () {
                    $scope.showResult = true;

                    if ($scope.find.DocumentTypes.length === 1) {
                        $scope.hidePanel();
                    }
                    else {
                        $scope.showPanel();
                    }

                    if ($scope.searchDocuments && $scope.searchDocuments.$dirty) {
                        $scope.hasCalendarBtn = false;
                    }

                    $scope.find.selectedDocumentTypes = $scope.aux.selectedDocumentTypes;
                    storageService.setDocumentFilter($scope.find);

                    var filters = {
                        Complete: true,
                        DocumentTypes: [],
                        ContainerTypes: [],
                        organizationUnitIds: []
                    };

                    filters.organizationUnitIds.push(auth.getOrganizationId());


                    if ($scope.documentTypes && $scope.documentTypes.length > 0) {
                        $scope.selectedDt = $filter('filter')($scope.documentTypes, { selected: true }, true)[0];
                        $scope.selectedDt.documentTypeId = $scope.selectedDt.id;
                    }

                    if ($scope.find.DocumentTypes.length > 0) {
                        $scope.selectedDt = $filter('filter')($scope.find.DocumentTypes, { showDetail: true }, true)[0];
                    }

                    $scope.find.DocumentTypes.forEach(function (type) {
                        type.allVersion = $scope.find.allVersion;
                        type.Page = !type.Page ? 1 : type.Page;
                        type.ItemPerPage = $scope.data.itemsPerPage;
                        type.showDetail = $scope.selectedDt !== null ? (type.documentTypeId === ($scope.selectedDt ? $scope.selectedDt.documentTypeId : 0)) : false;
                        type.organizationUnitIds = filters.organizationUnitIds;
                        // Evitamos la fecha 1900 en los metadatos de busqueda.
                        var dateMetadatas = $filter('filter')(type.metadatas, { metadataType: "date" }, true);
                        angular.forEach(dateMetadatas, function (item) {
                            if (item.metadataValueFrom < '19010101') {
                                item.metadataValueFrom = null;
                            }

                            if (item.metadataValueTo === '') {
                                item.metadataValueTo = null;
                            }
                        });
                        filters.DocumentTypes.push(type);
                    });

                    $scope.documentContainFilesFilter();

                    if ($scope.FindContainersAndDocuments()) {
                        if ($scope.find.containerType) {
                            $scope.find.containerType.allVersion = $scope.find.allVersion;
                            $scope.find.containerType.organizationUnitIds = filters.organizationUnitIds;
                            filters.ContainerTypes.push($scope.find.containerType);
                        }

                        $scope.parameters = {
                            documentType: { documentFullText: $scope.find.documentFullText, documentTypes: filters.DocumentTypes },
                            containerType: { containerTypes: filters.ContainerTypes },
                            header: $scope.getHeaderFilter()
                        };

                        return documentAndContainerFindService.get($scope.parameters).then(function getOk(result) {
                            $scope.findDocAndCont(result, true);
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                    else {
                        $scope.parameters = {
                            header: $scope.getHeaderFilter(),
                            documentFullText: $scope.find.documentFullText,
                            documentTypes: filters.DocumentTypes
                        };

                        return documentService.advancedGet($scope.parameters).then(function getOk(result) {
                            $scope.findDocAndCont(result, false);
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.getHeaderFilter = function () {
                    return {
                        documentHasFile: $scope.find.documentHasFiles,
                        documentName: $scope.find.documentNameFilter,
                        documentId: $scope.find.documentIdFilter,
                        documentNameType: $scope.find.documentNameType,
                        fileName: $scope.find.documentFileNameFilter,
                        fileNameType: $scope.find.fileNameType,
                        createdDateFrom: $scope.find.documentCreationDateFilterFrom < '19010101' ? null : $scope.find.documentCreationDateFilterFrom,
                        createdDateTo: $scope.find.documentCreationDateFilterTo < '19010101' ? null : $scope.find.documentCreationDateFilterTo,
                        createdBy: ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null
                    };
                };

                $scope.findDocAndCont = function (result, isDocContFind) {
                    $scope.itemsTmp = result.values;

                    if ($scope.itemsTmp.length > 0) {
                        $scope.accordionState.isOpen = false;
                    }

                    $scope.items = $scope.itemsTmp;
                    $scope.documentTypes = result.documentTypes;

                    if ($scope.documentTypes.length > 0) {
                        var selDt = $scope.documentTypes[0];

                        if ($scope.selectedDt) {
                            selDt = $filter('filter')($scope.documentTypes, { id: $scope.selectedDt.documentTypeId }, true)[0];
                        }

                        $scope.documentTypes.forEach(function (dt) {
                            if (dt.id === selDt.id) {
                                $scope.loadActions(dt.id);
                                dt.selected = true;
                                $scope.currentSelectedTypeIsShareable = dt.isShareable;
                            }
                        });
                    }

                    $scope.headers = result.headers;
                    $scope.sortableHeaders = result.sortableHeaders;
                    $scope.data.totalItems = result.valuesCount;
                    $scope.data.from = result.valuesFrom;
                    $scope.data.currentPage = isDocContFind ? $scope.parameters.documentType.documentTypes[0].Page : $scope.parameters.documentTypes.DocumentTypes[0].Page;
                };

                $scope.pageFind = function () {
                    $scope.items = [];
                    var find = storageService.getDocumentFilter();

                    if (find.DocumentTypes.length <= 0) {
                        $scope.data.totalItems = 0;
                        errors.showError('VerifyFormData');
                        return;
                    }

                    var filters = {
                        PartialQuery: true,
                        DocumentTypes: [],
                        organizationUnitIds: [],
                        ContainerTypes: []
                    };

                    filters.organizationUnitIds.push(auth.getOrganizationId());

                    find.DocumentTypes.forEach(function (type) {
                        type.Page = $scope.data.currentPage,
                            type.ItemPerPage = $scope.data.itemsPerPage;
                        type.organizationUnitIds = filters.organizationUnitIds;
                        // Evitamos la fecha 1900 en los metadatos de busqueda.
                        var dateMetadatas = $filter('filter')(type.metadatas, { metadataType: "date" }, true);
                        angular.forEach(dateMetadatas, function (item) {
                            if (item.metadataValueFrom < '19010101') {
                                item.metadataValueFrom = null;
                            }

                            if (item.metadataValueTo === '') {
                                item.metadataValueTo = null;
                            }

                        });
                        filters.DocumentTypes.push(type);
                    });

                    storageService.setDocumentFilter(find);

                    if ($scope.FindContainersAndDocuments()) {

                        if ($scope.find.containerType) {
                            $scope.find.containerType.allVersion = $scope.find.allVersion;
                            $scope.find.containerType.organizationUnitIds = filters.organizationUnitIds;
                            filters.ContainerTypes.push($scope.find.containerType);
                        }

                        $scope.parameters = {
                            documentType: { documentFullText: $scope.find.documentFullText, documentTypes: filters.DocumentTypes },
                            containerType: { containerTypes: filters.ContainerTypes },
                            header: $scope.getHeaderFilter()
                        }

                        return documentAndContainerFindService.get($scope.parameters).then(function getOk(result) {
                            $scope.itemsTmp = result.values;

                            if ($scope.itemsTmp.length > 0) {
                                $scope.accordionState.isOpen = false;
                            }

                            $scope.items = $scope.itemsTmp;
                            $scope.headers = result.headers;
                            $scope.sortableHeaders = result.sortableHeaders;
                            $scope.data.totalItems = result.valuesCount;
                            $scope.data.from = result.valuesFrom;

                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                    else {

                        $scope.parameters = {
                            header: $scope.getHeaderFilter(),
                            documentFullText: $scope.find.documentFullText,
                            documentTypes: filters.DocumentTypes
                        };

                        return documentService.advancedGet($scope.parameters).then(function getOk(result) {
                            $scope.itemsTmp = result.values;

                            if ($scope.itemsTmp.length > 0) {
                                $scope.accordionState.isOpen = false;
                            }

                            $scope.items = $scope.itemsTmp;
                            $scope.headers = result.headers;
                            $scope.sortableHeaders = result.sortableHeaders;
                            $scope.data.totalItems = result.valuesCount;
                            $scope.data.from = result.valuesFrom;

                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.view = function (document) {
                    storageService.setStateBackFind('document-advanced-find');
                    if ($scope.find.allVersion) {
                        $state.go('document-version-detail', { id: document.id, nro: document.nroVersion });
                    } else {
                        $state.go('document-detail', { id: document.id });
                    }
                };

                $scope.associateContainer = function () {
                    var checkDocs = [];

                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                checkDocs.push(docu);
                            }
                        });
                    }

                    if (checkDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    documentContainerService.setState('document-advanced-find');
                    documentContainerService.setDocuments(checkDocs);
                    $state.go('document-container-associate');
                };

                $scope.viewPDF = function (document) {
                    storageService.setStateBackFind('document-advanced-find');
                    $state.go('file-document-detail', { id: document.id, version: document.nroVersion });
                };

                $scope.viewVersion = function (document) {
                    storageService.setStateBackFind('document-advanced-find');
                    $state.go('document-version-all', { id: document.id });
                };

                $scope.goBackToCalendar = function () {
                    $state.go('calendar-view');
                };

                $scope.downloadFilesDocument = function (document) {
                    return fileService.downloadFilesDocument(document.id).then(function (result) {

                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.shareFilesDocument = function (document) {
                    storageService.setStateBackFind('document-advanced-find');
                    $state.go('share-document', { id: document.id });
                };

                $scope.selectType = function (type) {
                    $scope.currentSelectedTypeIsShareable = type.isShareable;

                    if (type.selected) {
                        return true;
                    };

                    $scope.documentTypes.forEach(function (dt) {
                        dt.selected = false;
                    });

                    type.selected = true;

                    $scope.find.DocumentTypes.forEach(function (dt) {
                        dt.showDetail = dt.documentTypeId === type.id;
                    });

                    $scope.findDocuments();
                };

                $scope.dropType = function (type) {
                    $scope.removeDocumentType(type);

                    var indexOf = -1;
                    var selected = false;
                    for (var i = 0; i < $scope.documentTypes.length; i++) {
                        if ($scope.documentTypes[i].id === type.id) {
                            indexOf = i;
                            selected = $scope.documentTypes[i].selected;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        $scope.documentTypes.splice(indexOf, 1);
                    }

                    if (selected) {
                        if ($scope.documentTypes.length <= 0) {
                            $scope.clean();
                        } else {
                            $scope.selectType($scope.documentTypes[0]);
                        }
                    }

                    storageService.setDocumentFilter($scope.find);
                };

                $scope.viewFromRow = function (event, document) {

                    if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                        if (event.target.parentElement !== null && event.target.parentElement.id === "doc") {
                            $scope.view(document);
                        }
                    }
                };

                $scope.checkOutAll = function () {
                    var checkDocs = [];
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                checkDocs.push(docu);
                            }
                        });
                    }

                    if (checkDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return documentService.checkOutAll(checkDocs).then(function () {
                        errors.showSuccess('DocumentCheckOutSucces');
                        $scope.checkAll = false;
                        $scope.checkUnCheckAll();
                    }, function (error) {
                        // TODO: Se deberían mostrar todos los errores en una ventana. 
                        // Por ahora se muestra el primero que es el error genérico.
                        errors.showError(error);
                        $scope.checkAll = false;
                        $scope.checkUnCheckAll();
                    });
                };

                $scope.downloadAll = function () {
                    var downloadDocs = [];
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                var doc = { id: docu.id, name: docu.name };
                                downloadDocs.push(doc);
                            }
                        });
                    }

                    if (downloadDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return documentAction.masiveDownloadFilesDocument(downloadDocs);
                };

                $scope.exportSelectedToExcel = function () {
                    var selected = [];

                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                var docu = { id: docu.id, name: docu.name };
                                selected.push(docu);
                            }
                        });
                    }

                    if (selected.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    var filters = {
                        Complete: false,
                        DocumentTypes: [],
                        ContainerTypes: [],
                        DocumentList: selected
                    };

                    var find = storageService.getDocumentFilter();

                    find.DocumentTypes.forEach(function (type) {
                        var filter = angular.copy(type);
                        filter.Page = 1,
                            type.ItemPerPage = 0;
                        filters.DocumentTypes.push(type);
                    });

                    if ($scope.FindContainersAndDocuments()) {

                        if ($scope.find.containerType) {
                            $scope.find.containerType.allVersion = $scope.find.allVersion;
                            $scope.find.containerType.organizationUnitIds = filters.organizationUnitIds;
                            filters.ContainerTypes.push($scope.find.containerType);
                        }


                        $scope.parameters = {
                            documentType: { documentTypes: filters.DocumentTypes },
                            containerType: { containerTypes: filters.ContainerTypes },
                            documentList: { documentList: selected },
                            header: $scope.getHeaderFilter()
                        }


                        return documentAndContainerFindService.exportToXLS($scope.parameters).then(function (result) {

                            var d = new Date();

                            var docTypeName = filters.DocumentTypes[0].documentTypeName;

                            for (var i = 0; i < filters.DocumentTypes.length; i++) {
                                if (find.DocumentTypes[i].showDetail == true) {
                                    docTypeName = find.DocumentTypes[i].documentTypeName;
                                }
                            }

                            var success = fileDownloader.saveAs(result.value, 'export' +
                                '-' +
                                d.getUTCFullYear() +
                                '-' +
                                (d.getUTCMonth() + 1) +
                                '-' +
                                d.getDate() +
                                'h' +
                                d.getHours() +
                                'm' +
                                d.getMinutes() +
                                's' +
                                d.getSeconds() +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            errors.showError('Api failed');

                        });
                    }
                    else {
                        $scope.parameters = {
                            Complete: false,
                            header: $scope.getHeaderFilter(),
                            documentFullText: $scope.find.documentFullText,
                            documentTypes: filters.DocumentTypes,
                            documentList:  selected 
                        }

                        return documentService.exportToXLS($scope.parameters).then(function (result) {

                            var d = new Date();

                            var docTypeName = filters.DocumentTypes[0].documentTypeName;

                            for (var i = 0; i < filters.DocumentTypes.length; i++) {
                                if (find.DocumentTypes[i].showDetail == true) {
                                    docTypeName = find.DocumentTypes[i].documentTypeName;
                                }
                            }

                            var success = fileDownloader.saveAs(result.value, 'export' +
                                '-' +
                                d.getUTCFullYear() +
                                '-' +
                                (d.getUTCMonth() + 1) +
                                '-' +
                                d.getDate() +
                                'h' +
                                d.getHours() +
                                'm' +
                                d.getMinutes() +
                                's' +
                                d.getSeconds() +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            errors.showError('Api failed');

                        });
                    }
                };



                $scope.exportToExcel = function () {
                    var filters = {
                        Complete: false,
                        DocumentTypes: [],
                        ContainerTypes: []
                    };

                    var find = storageService.getDocumentFilter();

                    find.DocumentTypes.forEach(function (type) {
                        var filter = angular.copy(type);
                        filter.Page = 1,
                            type.ItemPerPage = 0;
                        filters.DocumentTypes.push(type);
                    });

                    if ($scope.FindContainersAndDocuments()) {

                        if ($scope.find.containerType) {
                            $scope.find.containerType.allVersion = $scope.find.allVersion;
                            $scope.find.containerType.organizationUnitIds = filters.organizationUnitIds;
                            filters.ContainerTypes.push($scope.find.containerType);
                        }


                        $scope.parameters = {
                            documentType: { documentTypes: filters.DocumentTypes },
                            containerType: { containerTypes: filters.ContainerTypes },
                            header: $scope.getHeaderFilter()
                        };


                        return documentAndContainerFindService.exportToXLS($scope.parameters).then(function (result) {

                            var d = new Date();

                            var docTypeName = filters.DocumentTypes[0].documentTypeName;

                            for (var i = 0; i < filters.DocumentTypes.length; i++) {
                                if (find.DocumentTypes[i].showDetail === true) {
                                    docTypeName = find.DocumentTypes[i].documentTypeName;
                                }
                            }

                            var success = fileDownloader.saveAs(result.value, 'export' +
                                '-' +
                                d.getUTCFullYear() +
                                '-' +
                                (d.getUTCMonth() + 1) +
                                '-' +
                                d.getDate() +
                                'h' +
                                d.getHours() +
                                'm' +
                                d.getMinutes() +
                                's' +
                                d.getSeconds() +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            errors.showError('Api failed');

                        });
                    }
                    else {

                        $scope.parameters = {
                            Complete: false,
                            header: $scope.getHeaderFilter(),
                            documentFullText: $scope.find.documentFullText,
                            documentTypes: filters.DocumentTypes
                        }

                        return documentService.exportToXLS($scope.parameters).then(function (result) {

                            var d = new Date();

                            var docTypeName = filters.DocumentTypes[0].documentTypeName;

                            for (var i = 0; i < filters.DocumentTypes.length; i++) {
                                if (find.DocumentTypes[i].showDetail === true) {
                                    docTypeName = find.DocumentTypes[i].documentTypeName;
                                }
                            }

                            var success = fileDownloader.saveAs(result.value, 'export' +
                                '-' +
                                d.getUTCFullYear() +
                                '-' +
                                (d.getUTCMonth() + 1) +
                                '-' +
                                d.getDate() +
                                'h' +
                                d.getHours() +
                                'm' +
                                d.getMinutes() +
                                's' +
                                d.getSeconds() +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            errors.showError('Api failed');

                        });
                    }
                };

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.saveQueryAs = function () {

                    if ($scope.find.DocumentTypes.length < 1) {
                        return errors.showError('VerifyFormData');
                    }
                    $scope.find.selectedDocumentTypes = $scope.aux.selectedDocumentTypes;

                    var query = {
                        name: '',
                        type: 'Documents',
                        filters: JSON.stringify($scope.find)
                    };

                    return openModal(query).then(function (result) {

                        if (result && result.name && result.name !== '') {
                            query.name = result.name;
                            return userQueryService.create(query).then(function () {

                            }, function (error) {
                                errors.showError(error);
                            });
                        } else {
                            return;
                        }
                    });
                }

                $scope.saveQuery = function () {

                    if ($scope.find.DocumentTypes.length < 1) {
                        return errors.showError('VerifyFormData');
                    }

                    $scope.find.selectedDocumentTypes = $scope.aux.selectedDocumentTypes;

                    var query = storageService.getUserQuery();
                    query.filters = JSON.stringify($scope.find);

                    return userQueryService.modify(query).then(function (result) {

                        userQueryService.get('', 'Documents', null, null).then(function (result) {
                            $scope.optionsUserQueries = result.value;

                            $scope.userQueryId = storageService.getUserQuery().id;

                            $scope.actionFind();

                        }, function (error) {
                            errors.showError(error);
                        });
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                function setValue(scope, property, value) {
                    if (value) {
                        $q.when(value).then(function (val) {
                            scope[property] = val;
                        });
                    }
                }

                var modalController = function ($scope, $modalInstance, $translate, info) {
                    setValue($scope, 'title', info.name);
                    $scope.item = info;
                    $scope.ok = function () {
                        $modalInstance.close($scope.item);
                    };

                    $scope.cancel = function () {

                        $modalInstance.close();
                    };
                };
                modalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];

                function openModal(query) {
                    var modalInstance = $modal.open({
                        templateUrl: '/app/views/user-query/partial-query.html',
                        controller: modalController,
                        size: 'sm',
                        resolve: {
                            info: function () {
                                return {
                                    name: query.name
                                };
                            }
                        }
                    });

                    var result = modalInstance.result;
                    return result;
                }

                $scope.searchUser = function () {
                    if (!$scope.find.selectedUser || !$scope.find.selectedUser.nickName || $scope.find.selectedUser.nickName.length < 1) {
                        $scope.openModalUser();
                    }
                    else {
                        $scope.selectUser();
                    }
                };

                $scope.openModalUser = function () {
                    $scope.find.selectedUser = {};
                    var modalInstance = $modal.open({
                        templateUrl: '/app/directives/custom-control-user/custom-control-user-modal.html',
                        controller: 'UserSearchModalController',
                        size: 'lg',
                        resolve: {
                            ouId: function () {
                                return $scope.ouId;
                            },
                            info: function () {

                            }
                        }
                    });

                    modalInstance.result.then(function (result) {
                        if (result) {
                            $scope.find.selectedUser = result;
                        }
                        else {
                            $scope.find.selectedUser = {};
                        }
                    });
                };

                $scope.selectUser = function (item) {
                    userService.get($scope.find.selectedUser.nickName, null, null, null, null, null).then(function (result) {
                        if (result.value[0]) {
                            $scope.find.selectedUser = result.value[0];
                        }
                        else {
                            $scope.openModalUser();
                        }

                    }, function (result) {
                        $scope.openModalUser();
                    });
                };

                $scope.documentContainFilesFilter = function () {

                    $scope.documentHasFilesChecked = {
                        checkedYes: false,
                        checkedNo: false,
                        checkedAll: false

                    };

                    switch ($scope.find.documentHasFiles) {
                        case "YES":
                            $scope.documentHasFilesChecked.checkedYes = true;
                            break;
                        case "NO":
                            $scope.documentHasFilesChecked.checkedNo = true;
                            break;
                        default:
                            $scope.documentHasFilesChecked.checkedAll = true;
                            $scope.find.documentHasFiles = 'ALL';
                            break;
                    }
                };

                $scope.Load();
            }])
        .directive('document', function () {
            return {
                restrict: 'E',
                link: function (scope, elem, attrs) {
                    if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                        elem.on('click', function (e) {
                            e.preventDefault();
                        });
                    }
                }
            };
        });

})();